import React from 'react';
import {Link} from "react-router-dom";
import {ProductsMenu} from "./Products";
import {Helper} from "./Helper";

export default class ProductsBarcode extends React.Component {
	constructor(props) {
		super(props);

		let _state = {};
		_state.params = {};
		window.Route.on({
			'/v2/products/:product_id/barcode': (params) => {
				_state = {
					mode: 'list',
					product: false,
					product_barcode: false,
					params: params,
					products: [],
					product_barcodes: [],

				};
			},
			'/v2/products/:product_id/barcode/new': (params) => {
				_state = {
					mode: 'create',
					product: false,
					product_barcode: false,
					params: params,
					products: [],
					product_barcodes: [],

				};
			},
			'/v2/products/:product_id/barcode/:product_barcode_id/edit': (params) => {
				_state = {
					mode: 'edit',
					product: false,
					product_barcode: false,
					params: params,
					products: [],
					product_barcodes: [],

				};
			},
		}).match();
		_state.is_loading = true;
		_state.qs = window.Global.getAllQueryStrings();
		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/products/:product_id/barcode': (params) => {
					this.setState({
						mode: 'list',
						is_loading: true,
						product: false,
						product_barcode: false,
						params: params,
						products: [],
						product_barcodes: [],

					}, () => {
						this.fetch();
					});
				},
				'/v2/products/:product_id/barcode/new': (params) => {
					this.setState({
						mode: 'create',
						is_loading: true,
						product: false,
						product_barcode: false,
						params: params,
						products: [],
						product_barcodes: [],
						qs: window.Global.getAllQueryStrings(),
					}, () => {
						this.create()
					});
				},
				'/v2/products/:product_id/barcode/:product_barcode_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						is_loading: true,
						product: false,
						product_barcode: false,
						params: params,
						products: [],
						product_barcodes: [],
						qs: window.Global.getAllQueryStrings(),
					}, () => {
						this.edit()
					});
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				mode: 'list',
				is_loading: true,
				product: false,
				products: [],
				product_price_condition: [],
				qs: window.Global.getAllQueryStrings(),
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'create') {
			this.create();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}

	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product_barcode',
			data: {
				product_id: this.state.params.product_id,
				...this.state.qs,
			},
			done: (response) => {
				this.setState({
					product: response.product,
					product_barcodes: response.product_barcode,
					is_loading: false,
				}, () => {
					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.product_barcode,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				})

			},
			fail: () => {

			}
		});
	}

	create() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product_barcode',
			data: {
				product_id: this.state.params.product_id,
			},
			done: (response) => {
				this.setState({
					product: response.product,
					// product_barcode: response.product_barcode[0],
					is_loading: false,
				}, () => {
					let $e = window.GlobalFunc.setupQuantityAndRatio(this.ratio, {
						product: this.state.product,
						quantity: this.state.product.default_item_sell.quantity || 1,
						input_quantity: 'qty',
						ratio: this.state.product.default_item_sell.ratio,
						input_ratio: 'ratio',
						quantityReadOnly: false,
						// onChange: (item) => {
						//     this.state.product.quantity = item.quantity;
						//     this.state.product.ratio = item.ratio;
						// }
					});
					$e.attr('class', '');

					window.GlobalFunc.setQuantityUnitName(window.$(this.ref), {
						$quantity: $e.find('input[name="qty"]'),
						quantity: 1,
						ratio: this.state.product.ratio,
						$unit_name_dropdown: $e.find('.Item_selectUnitName'),
						product: this.state.product,
					})
					$e.find('input[name="user_input_quantity"]').attr('style', '');
				})

			},
			fail: () => {

			}
		});
	}

	edit() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product_barcode',
			data: {
				product_id: this.state.params.product_id,
			},
			done: (response) => {
				let product = response.product;
				window.Global.ajax({
					method: 'GET',
					url: process.env.REACT_APP_DOMAIN + '/api/product_barcode',
					data: {
						product_barcode_id: this.state.params.product_barcode_id,
					},
					done: (response) => {
						// console.log(response);
						this.setState({
							product: product,
							product_barcode: response.product_barcode[0],
							is_loading: false,
						}, () => {
							let $e = window.GlobalFunc.setupQuantityAndRatio(this.ratio, {
								product: this.state.product,
								quantity: this.state.product_barcode.qty || 1,
								input_quantity: 'qty',
								ratio: this.state.product_barcode.ratio,
								input_ratio: 'ratio',
								quantityReadOnly: false,
								// onChange: (item) => {
								//     this.state.product.quantity = item.quantity;
								//     this.state.product.ratio = item.ratio;
								// }
							});
							$e.attr('class', '');

							window.GlobalFunc.setQuantityUnitName(window.$(this.ref), {
								$quantity: $e.find('input[name="qty"]'),
								quantity: this.state.product_barcode.qty || 1,
								ratio: this.state.product.ratio,
								$unit_name_dropdown: $e.find('.Item_selectUnitName'),
								product: this.state.product,
							})
							$e.find('input[name="user_input_quantity"]').attr('style', '');


						})

					},
					fail: () => {

					}
				});
			},
			fail: () => {

			}
		});


	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className={"section active"}
							      to={"/v2/products"}>สินค้า</Link>
							{
								this.state.product ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<div className="section">
											{this.state.product.name} ({this.state.product.code})
										</div>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className="section active">
								บาร์โคด
							</div>
						</div>
						<div className="right floated">
							<Link id="addProductButton" to={"/v2/products/" + this.state.product.id + "/barcode/new"}
							      className="ui positive button">เพิ่มบาร์โค้ดใหม่</Link>
						</div>
					</div>
					<ProductsMenu product_id={this.state.product.id}
					              index={2}
					              search_barcode={this.state.mode === "list"}
					              barcode_input_value={this.state.qs.search_barcode}
					              onSearchSubmit={(obj) => {
						              this.props.history.push({
							              pathname: '/v2/products/' + this.state.product.id + '/barcode',
							              state: null,
							              search: "?search_barcode=" + obj.search_barcode + '&page=' + obj.page,
						              });
					              }}
					/>
				</div>
				<div className="flex row wrap ">
					<div className="ui basic table can click Table_root " style={{marginTop: 10}}>
						<div className="thead">
							<div className="tr">
								<div className="th span4">บาร์โคด</div>
								<div className="th span4">จำนวน</div>
								<div className="th span4">วันที่สร้าง</div>
								<div className="th span4">วันที่แก้ไข</div>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.is_loading
									? <div className="tr">
										<div className="td center aligned" data-info="nodata">
											<div className="ui active centered inline small loader"/>
										</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.product_barcodes.length === 0
								&& (
									!window.Global.getAllQueryStrings().page
									|| window.Global.getAllQueryStrings().page === '1'
								) ?
									<div className="tr">
										<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.product_barcodes.length > 0 ?
									this.state.product_barcodes.map((product_barcode, product_barcode_i) => {
										let redirect_url = "/v2/products/" + this.state.product.id + "/barcode/" + product_barcode.id + "/edit";
										return (
											<div
												onClick={(e) => {
													if (!window.$(e.target).is("button")
														&& !window.$(e.target).is("i")) {
														this.props.history.push({
															pathname: redirect_url,
															state: null,
														});
													}
												}}
												// to={redirect_url}
												className="tr" key={product_barcode_i}>
												<div className="td span4">
													<span>
														<i className="ui icon barcode"/> {product_barcode.barcode}
													</span>
													{
														product_barcode.title_1 ?
															<span>{product_barcode.title_1}</span>
															: null
													}
													{
														product_barcode.title_2 ?
															<span>{product_barcode.title_2}</span>
															: null
													}
													{
														product_barcode.title_3 ?
															<span>{product_barcode.title_3}</span>
															: null
													}
													{
														product_barcode.title_4 ?
															<span>{product_barcode.title_4}</span>
															: null
													}
													{
														product_barcode.title_5 ?
															<span>{product_barcode.title_5}</span>
															: null
													}
												</div>
												<div className="td span4">
													{
														window.GlobalFunc.getUnitNameByQuantity2({
															product: this.state.product,
															quantity: product_barcode.qty
														})['text']
													}
												</div>
												<div className="td span4">
													{
														product_barcode.date_created ?
															window.Global.getDateThai(product_barcode.date_created, {is_show_time: false})
															: "-"
													}
												</div>
												<div className="td span4">
													<div className="flex row middle-xs">
														<div>
															{
																product_barcode.date_updated ?
																	window.Global.getDateThai(product_barcode.date_updated, {is_show_time: false})
																	: "-"
															}
														</div>
														<div className="right floated">
															<button type="button" className="ui icon basic button"
															        onClick={(e) => {
																        var num = parseInt(window.prompt("ระบุจำนวน", 30));

																        var $svg = window.$('<div><svg id="barcode"></svg></div>');
																        $svg.find('#barcode').JsBarcode(product_barcode.barcode, {
																	        // format: 'upc',
																	        width: 3,
																	        textMargin: 0,
																	        fontSize: 28
																	        // fontOptions: 'bold'
																        });
																        if (num) {
																	        window.PreviewPdf.open({
																		        svg: $svg.html(),
																		        barcode: product_barcode,
																		        margin: 0,
																		        padding: 10,
																		        height: 177,
																		        barcodes: new Array(num)
																	        }, 'barcode', {
																		        url: process.env.REACT_APP_DOMAIN + '/api/document'
																	        });
																        }
															        }}
															>
																<i className="icon print"/>
															</button>
														</div>
													</div>
												</div>
											</div>
										)
									}) : null
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		if (!this.state.product) {
			return <div className="ui active centered inline loader"/>
		}
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		return (
			<>
				<div ref={(ref) => {
					if (!ref) return;
					this.$parent = window.$(ref);
					this.$parent.find('form').form2('submit', {
						method: this.state.mode === 'create' ? 'POST' : 'PUT',
						url: process.env.REACT_APP_DOMAIN + '/api/product_barcode',
						beforeSent: (object) => {
							object._qty = object.user_input_quantity;
							delete object.user_input_quantity;
							return object;
						},
						loadingButton: window.$(this.$parent).find('#submit-button'),
						onSuccess: (response) => {
							window.Global.messageTop({
								type: 'positive',
								message: this.state.mode === 'create' ? 'เพิ่มบาร์โคดเรียบร้อย' : 'แก้ไขบาร์โคดเรียบร้อย'
							});
							this.props.history.push({
								pathname: '/v2/products/' + this.state.product.id + '/barcode',
								state: null
							});

						}
					});
				}}
				     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				     className="main ui container">
					<div style={{marginBottom: '1rem'}}>
						<div className="flex row wrap middle-xs">
							<div className="ui huge breadcrumb">
								<Link className={"section active"}
								      to={"/v2/products"}>สินค้า</Link>
								{
									this.state.product ?
										<>
											<span className="divider" style={{margin: '0px 1rem'}}>/</span>
											<Link to={"/v2/products/" + this.state.product.id + '/barcode'}
											      className="section">
												{this.state.product.name} ({this.state.product.code})
											</Link>
										</>
										: null
								}
								<span className="divider" style={{margin: '0px 1rem'}}>/</span>
								<div className="section">
									{
										this.state.mode === 'create' ?
											"เพิ่มบาร์โคด" : null
									}
									{
										this.state.mode === 'edit' ?
											"แก้ไขบาร์โคด " + this.state.product_barcode.barcode : null
									}
								</div>
							</div>
						</div>
						<ProductsMenu product_id={this.state.product.id}
						              index={2}
						/>
					</div>
					<div id="ProductBarcodeEdit_root">
						<form className="ui form" autoComplete="off">
							<div className="ui grid ui tall stacked segment" style={{marginTop: 0}}>
								<div className={"flex row wrap two column computer"}>
									<div className={"column"}>
										<h4 className="ui dividing header">รายละเอียด</h4>
										<div className="field">
											<label>บาร์โคด</label>
											<div className="ui left icon input">
												<input type="text"
												       name="barcode"
												       placeholder="Barcode"
												       defaultValue={this.state.product_barcode.barcode || ''}
												/>
												<i className="barcode icon"/>
											</div>
										</div>
										<div className="field">
											<label>จำนวน</label>
											{
												this.state.product ?
													<div id={"ratio"}
													     ref={(ref) => {
														     this.ratio = window.$(ref);
													     }}
													/>
													: null
											}
										</div>
									</div>
									<div className={"column"}>
										<h4 className="ui dividing header">คำอธิบาย</h4>
										<div className="field">
											<label>คำอธิบาย 1
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_1"]').val(this.state.product.name)
												      }}
												>
													ใช้ชื่อสินค้า
												</span>
											</label>
											<input type="text" name="title_1"
											       defaultValue={this.state.product_barcode.title_1 || ''}/>
										</div>
										<div className="field">
											<label>คำอธิบาย 2
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_2"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + ' บาท')
												      }}
												>
													(ใช้ราคา #1)
												</span>
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_2"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + '.-')
												      }}
												>
													(ใช้ราคา #2)
												</span>
											</label>
											<input type="text" name="title_2"
											       defaultValue={this.state.product_barcode.title_2 || ''}/>
										</div>
										<div className="field">
											<label>คำอธิบาย 3
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_3"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + ' บาท')
												      }}
												>
													(ใช้ราคา #1)
												</span>
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_3"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + '.-')
												      }}
												>
													(ใช้ราคา #2)
												</span>
											</label>
											<input type="text" name="title_3"
											       defaultValue={this.state.product_barcode.title_3 || ''}/>
										</div>
										<div className="field">
											<label>คำอธิบาย 4
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_4"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + ' บาท')
												      }}
												>
													(ใช้ราคา #1)
												</span>
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_4"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + '.-')
												      }}
												>
													(ใช้ราคา #2)
												</span>
											</label>
											<input type="text" name="title_4"
											       defaultValue={this.state.product_barcode.title_4 || ''}/>
										</div>
										<div className="field">
											<label>คำอธิบาย 5
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_5"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + ' บาท')
												      }}
												>
													(ใช้ราคา #1)
												</span>
												<span className="link auto-button"
												      style={{marginLeft: 5}}
												      onClick={() => {
													      window.$('input[name="title_5"]').val(Helper.getRatioUnit(this.state.product, this.ratio.find("[name='ratio']").val()).default_item_sell.price.format(2) + '.-')
												      }}
												>
													(ใช้ราคา #2)
												</span>
											</label>
											<input type="text" name="title_5"
											       defaultValue={this.state.product_barcode.title_5 || ''}/>
										</div>
									</div>
								</div>
								<div className="column row">
									<div className="column">
										<div className="ui error message"/>
										<div className="flex row">
											{
												this.state.mode === 'edit' ?
													<>
														<input type="hidden" name="product_barcode_id"
														       defaultValue={this.state.product_barcode.id}/>
														<button className="ui red button" type="button" onClick={() => {
															this.void();
														}}>ลบ
														</button>
													</>
													: null
											}
											{
												this.state.mode === 'create' ?
													<input type="hidden" name="product_id"
													       defaultValue={this.state.product.id}/>
													: null
											}
											<div className="right floated">
												<Link id="cancelButton"
												      to={"/v2/products/" + this.state.product.id + "/barcode"}
												      className="ui button">ยกเลิก</Link>
												<button className="ui right floated primary button"
												        type="submit">บันทึก
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</>
		);
	}

	void() {
		window.Global.confirm({
			title: 'ยืนยันลบข้อมูล',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/product_barcode',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.product_barcode_id = this.state.product_barcode.id;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						this.props.history.push({
							pathname: '/v2/products/' + this.state.product.id + '/barcode',
							state: null
						});
					}
				});
			}
		});
	}
}
